<template>
    <transition-group name="kt-anim" tag="div" class="kt-stack" :class="{ 'kt-stack--mobile': isMobile }">
        <toast-card v-for="toast in toasts" :key="toast.id" class="kt-item" :variant="variant(toast.color)"
            :icon="variantIcon(toast.color)" :text="toast.text" @close="hideSnackBar(toast.id)" />
    </transition-group>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ToastCard from "@/components/common/ToastCard";

const TOAST_TIMEOUT = 3000

export default {
    name: "KimsaToast",
    components: { ToastCard },
    data() {
        return {
            timers: {},
        }
    },
    computed: {
        ...mapState(['toasts']),
    },
    beforeDestroy() {
        const vm = this
        Object.values(vm.timers).forEach(timer => clearTimeout(timer))
        vm.timers = {}
    },
    methods: {
        ...mapMutations(['hideSnackBar']),
        variant(color = '') {
            if (color.includes('error')) return 'error'
            if (color.includes('success')) return 'success'
            return 'info'
        },
        variantIcon(color = '') {
            const variant = this.variant(color)
            if (variant === 'error') return 'mdi-alert-circle-outline'
            if (variant === 'success') return 'mdi-check-circle-outline'
            return 'mdi-information-outline'
        },
    },
    watch: {
        toasts(val) {
            const vm = this
            val.forEach(toast => {
                if (vm.timers[toast.id]) return
                vm.timers[toast.id] = setTimeout(() => {
                    vm.hideSnackBar(toast.id)
                    delete vm.timers[toast.id]
                }, TOAST_TIMEOUT)
            })
        },
    },
}
</script>

<style scoped>
.kt-stack {
    position: fixed;
    z-index: 1000;
    top: 16px;
    right: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 340px;
    max-width: calc(100% - 32px);
    pointer-events: none;
}

.kt-stack--mobile {
    top: auto;
    left: 16px;
    right: 16px;
    width: auto;
    max-width: none;
    bottom: calc(16px + var(--safe-area-inset-bottom, 0px));
}

.kt-item {
    pointer-events: auto;
}

.kt-anim-move {
    transition: transform .2s ease;
}

.kt-anim-enter-active,
.kt-anim-leave-active {
    transition: opacity .2s ease, transform .2s ease;
}

.kt-anim-enter,
.kt-anim-leave-to {
    opacity: 0;
    transform: translateX(16px);
}

.kt-stack--mobile .kt-anim-enter,
.kt-stack--mobile .kt-anim-leave-to {
    transform: translateY(16px);
}
</style>
